module.exports = require('fast-json-stable-stringify')
